import { type View, VIEWS } from '@/core/domain/users/LocalUser.ts'

/**
 * Résolution d'un type de vue de unknown à View
 * @param raw
 * @constructor
 */
export function resolveView(raw: unknown) : View {
  const VIEW_SET = new Set<string>(VIEWS)
  const normalised = String(raw ?? '').trim().toLowerCase()
  if (VIEW_SET.has(normalised)) return raw as View
  return 'public'
}